<button type="button" class="btn btn-primary" (click)="add()">Add address</button>
<button type="button" class="btn btn-primary ms-2" (click)="calculateRoute()">Calculate Route</button>

<!-- <app-file-upload [fileExtensions]="['.csv', '.xlsx']"></app-file-upload> -->
<div class="row">
    <table>
        <tr>
            <th></th>
            <th>Address</th>
        </tr>
        @for(wp of waypoints(); track $index) {

        <tr>
            <td>
                {{$index+1}}
            </td>
            <td>
                <app-address-selector
                    (addressSelected)="addressSelected($event, $index)"
                    [id]="'address-' + $index"
                    [country]="'ar'"
                    [label]="'Address ' + ($index + 1)"
                    [placeholder]="'Type an address'"
                    [ngModel]="waypoints()[$index]"
                    (ngModelChange)="updateAddress($index, $event)"></app-address-selector>
            </td>

        </tr>
        }
    </table>

    <a href="{{url()}}" target="_blank" class="btn btn-link mt-3">
        View Route on Google Maps

    </a>
</div>